<template>
  <section class="insider-product-page">
    <div v-if="isArticle" class="insider-product-page__report">
      <div class="insider-product-page__header">
        <div>
          <h1 class="insider-product-page__title">
            {{ selectedProduct.reportTitle || 'Report' }}
            <br />
            <small class="report__subtitle">
              {{ selectedProduct.reportSubTitle || '' }}
            </small>
          </h1>
        </div>
        <div>
          <img
            src="/images/logos/insider-logo.png"
            alt="Insider Logo"
            class="insider-product-page__logo"
          />
        </div>
      </div>
      <div id="reports" class="vueComponent">
        <ReportComponent
          :app-url="appUrl"
          :report_to_view="selectedProduct.reportType"
          :template="selectedProduct.template || null"
        />
      </div>
    </div>
    <div v-else>
      <div class="insider-product-page__header">
        <div>
          <h1 class="insider-product-page__title">
            {{ selectedProductType.replaceAll('-', ' ') }}
          </h1>
        </div>
        <div>
          <img
            src="/images/logos/insider-logo.png"
            alt="Insider Logo"
            class="insider-product-page__logo"
          />
        </div>
      </div>
      <div
        :class="
          isAnnouncement
            ? 'insider-product-page__content announcement'
            : 'insider-product-page__content'
        "
      >
        <div v-if="!isAnnouncement" class="insider-product-page__content">
          <div class="insider-product-page__content-image" v-if="isUnpublished">
            <img
              :src="selectedProduct.image"
              class="product-image"
              alt="Product Image"
            />
          </div>
          <div
            class="insider-product-page__content-default"
            v-else-if="!selectedProduct.vimeo_id && !selectedProduct.youtube_id"
          >
            <h3>No video currently exists for {{ selectedProduct.title }}</h3>
          </div>
          <div class="insider-product-page__content-video" v-else>
            <iframe
              v-if="selectedProduct.vimeo_id"
              :src="getVimeoVideo()"
              frameborder="0"
              webkitAllowFullScreen
              mozallowfullscreen
              allowFullScreen
              class="insider-product-page__vimeo-video"
            />
            <iframe
              v-if="selectedProduct.youtube_id"
              :src="getYTVideo()"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
              class="insider-product-page__youtube-video wide-video"
              :class="{ faded: isIframeFaded }"
            ></iframe>
          </div>
        </div>
        <div
          :class="
            isAnnouncement
              ? 'insider-product-page__content-meta-full'
              : 'insider-product-page__content-meta'
          "
        >
          <h3
            :class="
              !isAnnouncement
                ? 'insider-product-page__content-meta-title'
                : 'insider-product-page__content-meta-full-title'
            "
          >
            {{ selectedProduct.title }}
          </h3>
          <p class="insider-product-page__content-meta-date">
            {{ displayDate }}
          </p>
          <div v-html="selectedProduct.short_description" />
          <BaseButton
            v-if="selectedProduct.attachment"
            @click="downloadSlides(selectedProduct.attachment)"
            class="insider-product-page__content-meta-button"
          >
            DOWNLOAD SLIDES
          </BaseButton>
        </div>
      </div>
      <div class="insider-product-page__carousel-title">
        <h2 clas="insider-prodcut-page__title">
          {{ isAnnouncement ? 'Read' : 'Watch' }} More...
        </h2>
      </div>
      <InsiderCarousel
        :article-list="displayProducts"
        :item-type="getCarouselValidator(selectedProductType)"
        @product-selected="
          handleProductSelected($event, selectedProductType, moreProducts)
        "
      />
    </div>

    <div class="insider-product-page__store-container">
      <div class="insider-product-page__store-itr">
        <img
          src="/images/app-store-itr.png"
          alt="App Store ITR"
          class="insider-product-page__store-image"
        />
        <p class="insider-product-page__store-text">
          insider is on the itr ondemand app!
        </p>
      </div>
      <div class="insider-product-page__store-apps">
        <a
          href="https://play.google.com/store/apps/details?id=com.itrondemand.itrappdev&hl=en_US&gl=US"
          target="_blank"
        >
          <img
            src="/images/app-store-android-tr.png"
            alt="App Store Android"
            class="insider-product-page__app-image"
          />
        </a>
        <a
          href="https://apps.apple.com/us/app/itr-ondemand/id1528665160"
          target="_blank"
        >
          <img
            src="/images/app-store-apple-tr.png"
            alt="App Store Apple"
            class="insider-product-page__app-image"
          />
        </a>
      </div>
    </div>
  </section>
</template>

<script>
  import BaseButton from '~/components/base/BaseButton.vue';
  import ReportComponent from '~/components/report/ReportComponent.vue';
  import InsiderCarousel from '~/components/insider/InsiderCarousel.vue';

  export default {
    name: 'insider-product-page',
    components: {
      BaseButton,
      ReportComponent,
      InsiderCarousel,
    },
    props: {
      authUser: {
        type: Object,
        required: true,
      },
      selectedProduct: {
        type: Object,
        required: true,
      },
      selectedProductType: {
        type: String,
        required: true,
      },
      moreProducts: {
        type: Array,
        required: true,
      },
      appUrl: {
        type: String,
        required: true,
      },
    },
    data: () => ({
      isIframeFaded: false,
    }),
    mounted() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      let menuItem = this.getNavMenuItem(this.selectedProductType);
      const event = new CustomEvent('menu-clicked', {
        detail: {
          menuItem: menuItem,
        },
      });
      setTimeout(() => {
        window.dispatchEvent(event);
      }, 1000);
    },
    computed: {
      displayProducts() {
        if (this.isArticle) {
          return this.moreProducts.filter(
            (product) =>
              product.id !== this.selectedProduct.type.id && product.image
          );
        }
        if (this.isAnnouncement) {
          return this.moreProducts.filter(
            (product) => product.id !== this.selectedProduct.id
          );
        }
        return this.moreProducts.filter(
          (product) => product.id !== this.selectedProduct.id && product.image
        );
      },
      displayDate() {
        if (!this.selectedProduct.publish_date) return 'Coming Soon';
        let parsedTimeStamp = new Date(this.selectedProduct.publish_date);
        if (this.selectedProductType.includes('webinar')) {
          return parsedTimeStamp.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
          });
        }
        return parsedTimeStamp.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });
      },
      isArticle() {
        return this.selectedProductType === 'latest-economic-articles';
      },
      isAnnouncement() {
        return this.selectedProductType === 'recent-announcement';
      },
      isWebinar() {
        return this.selectedProductType.includes('webinar');
      },
      isTrendsTalk() {
        return this.selectedProductType.includes('talk');
      },
      productIconSrc() {
        return `/images/product/icons/${this.selectedProduct.product.toLowerCase().replace(/ /g, '')}-icon.svg`;
      },
      isUnpublished() {
        const publishedDate = new Date(this.selectedProduct.publish_date);
        const currentDate = new Date();
        return currentDate < publishedDate;
      },
    },
    methods: {
      getVimeoVideo() {
        return `https://player.vimeo.com/video/${this.selectedProduct.vimeo_id}`;
      },
      getYTVideo() {
        return `https://www.youtube.com/embed/${this.selectedProduct.youtube_id}`;
      },
      downloadSlides(attachment) {
        const link = document.createElement('a');
        link.href = attachment;
        link.download = attachment.substr(attachment.lastIndexOf('/') + 1);
        link.click();
      },
      async handleProductSelected(product, productType, moreProducts) {
        if (productType.includes('webinar') && !product.purchased) {
          window.location.href = product.url;
          return;
        }

        if (this.isWebinar && !product.vimeo_id) {
          return;
        }

        if (this.isTrendsTalk && !product.youtube_id) {
          return;
        }
        let productTypeSlug = this.getUrlProductType(productType);
        return (window.location.href = `/insider/${productTypeSlug}/${product.slug}`);
      },
      getNavMenuItem(productType) {
        switch (productType) {
          case 'business-series-webinar':
            return 'insider-business-series-webinars';
          case 'latest-economic-articles':
            return 'insider-latest-economic-articles';
          case 'executive-series-webinar':
            return 'insider-executive-series';
          case 'TrendsTalk':
            return 'insider-trends-talks';
          case 'recent-announcement':
            return 'insider-recent-announcements';
          case 'itr-academy':
            return 'insider-itr-academy';
          default:
            return 'insider-additional-resources';
        }
      },
      getUrlProductType(productType) {
        switch (productType) {
          case 'business-series-webinar':
            return 'business-series-webinars';
          case 'latest-economic-articles':
            return 'latest-economic-articles';
          case 'executive-series-webinar':
            return 'executive-series-webinars';
          case 'TrendsTalk':
            return 'trendstalk';
          case 'recent-announcement':
            return 'recent-announcement';
          default:
            return 'insider';
        }
      },
      getCarouselValidator(productType) {
        switch (productType) {
          case 'business-series-webinar':
            return 'business-series-webinar';
          case 'latest-economic-articles':
            return 'latest-economic-articles';
          case 'executive-series-webinar':
            return 'executive-series-webinar';
          case 'TrendsTalk':
            return 'trends-talk';
          case 'recent-announcement':
            return 'recent-announcements';
          default:
            return 'business-series-webinar';
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .insider-product-page {
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 2rem;
      @include screen-lg {
        margin-bottom: 4rem;
      }
    }
    &__logo {
      height: 48px;
      width: 48px;
      margin-left: 10px;
    }
    &__report {
      margin-bottom: 3rem;
    }
    &__carousel-title {
      h2 {
        margin-bottom: 1em;
      }
    }
    &__title {
      font-size: 2rem;
      font-weight: 700;
      text-transform: capitalize;
      margin-right: 10px;
    }
    &__content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      gap: 2rem;
      width: 100%;
      @include screen-md {
        flex-direction: row;
      }
    }
    &__content.announcement {
      width: 100%;
      margin: 0 auto;
      @include screen-lg {
        width: 60%;
      }
    }
    &__content-video {
      width: 100%;
      // flex: 1 auto;
    }
    &__vimeo-video {
      margin-bottom: 1rem;
    }
    &__vimeo-video,
    &__youtube-video {
      width: 100%;
      height: 250px;
      @include screen-md {
        height: 600px;
      }
    }
    .wide-video {
      width: 100%;
    }
    &__content-image {
      height: 600px;
      width: 100%;
      .product-image {
        object-fit: cover;
        object-position: center;
      }
    }
    &__youtube-video {
      width: 100%;
      height: 250px;
      margin-bottom: 2em;
      @include screen-md {
        height: 600px;
      }
    }
    &__content-meta {
      width: 90%;
      text-align: left;
      margin-bottom: 2em;
      @include screen-md {
        width: 33.3333%;
        text-align: right;
        margin-bottom: 0;
      }
      &-date {
        font-size: 18px;
        font-weight: 900;
        margin-bottom: 1rem;
        color: var(--itr-grey-mid);
        @include screen-lg {
          margin-bottom: 3rem;
        }
      }
      &-button {
        margin-top: 2rem;
        text-transform: uppercase;
      }
    }
    &__content-meta-full {
      margin-bottom: 1rem;
      &-title {
        @include screen-lg {
          font-size: 30px;
          margin-bottom: 2rem;
        }
      }
    }
    &__content-meta-title {
      color: var(--itr-blue-mid);
      margin-bottom: 1rem;
      @include screen-lg {
        font-size: 30px;
        margin-bottom: 3rem;
      }
    }
    &__store-container {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 2rem;
      width: 100%;
      padding: 4rem 2rem;
    }
    &__store-itr {
      display: flex;
      align-items: center;
      gap: 10px;
      justify-content: center;
      flex-wrap: wrap;
    }
    &__store-image {
      width: 75px;
      height: 75px;
    }
    &__store-text {
      color: var(--itr-green-mid);
      max-width: 105px;
      font-weight: 600;
      font-size: 12px;
      text-transform: uppercase;
      text-align: center;
      line-height: 1;
    }
    &__store-apps {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
    }
    &__app-image {
      width: 175px;
      height: 50px;
      object-fit: contain;
    }
    .faded {
      opacity: 0;
      transition: opacity 0.4s ease-in-out;
    }
  }
</style>
